<template>
  <div class="page_bg error_page" style="">
    <div class="error_page_logo">
      <van-image width="2.67rem" height="0.85rem"
                 src="https://oss.xiaoyi120.com/wholesale2/login/login_logo_szxq2.png"
      />
    </div>
    <van-image width="10rem" height="8.53rem" src="https://oss.xiaoyi120.com/wholesale2/login/login_bg_szxq2.png" />
    <div class="error_page_tip">无法注册/登录</div>
    <div class="error_page_msg">该账号已注册四爪星球</div>
    <div class="error_page_btn flex-r-sa-c">
      <div />
      <van-button round block type="info" native-type="submit" color="#0767ab" style="font-size: 0.4rem;width: 9.07rem;"
                  @click="openKeFu"
      >咨询客服 </van-button>
      <div />
    </div>
    <!-- 客服组件 -->
    <kefuBtn ref="mykefuBtn" />
  </div>
</template>

<script>
import kefuBtn from '@/components/kefu_btn'
export default {
  components: { kefuBtn },
  data() {
    return {

    }
  },
  methods: {
    reLogin() { this.$router.push('/user/login') },
    openKeFu() { this.$refs.mykefuBtn.changeShow(true) }
  }
}
</script>

<style lang="scss">
.error_page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 10rem;
  max-height: 19.31rem;
  background: linear-gradient(180deg, #e9f3ff 0%, #f6faff 15.06%, #fff 100%);
  .error_page_logo {
    width: 100%;
    text-align: left;
    padding-bottom: 1.97rem;
    padding-top: 0.43rem;
    padding-left: 0.53rem;
  }
  .van-image {
  }
  &_tip {
    font-size: 0.48rem;
    color: #333333;
    margin-top: 0.11rem;
  }
  &_msg {
    font-size: 0.37rem;
    color: #999999;
    margin-top: 0.11rem;
  }
  &_btn {
    margin-top: 1rem;
    width: 100%;
    .van-button {
      width: 3.2rem;
    }
  }
}
</style>
